module.exports = "<div class=\"layout-wrap\">\n    <app-main-header *ngIf=\"loading\"\n                     [loginUser]=\"loginUser\"\n                     [curLang]=\"userLang\"></app-main-header>\n    <!--<app-main-submenu *ngIf=\"loading\"></app-main-submenu>-->\n    <router-outlet *ngIf=\"loading\"></router-outlet>\n    <app-main-footer *ngIf=\"loading\"></app-main-footer>\n\n    <msg-popup></msg-popup>\n    <div [class.spinner]=\"!loading\"></div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main